<nav 
	role="none" 
	id="pcgMainNavigation" 
	class="navbar"
>
	<!--#region Mobile header -->
	@if (
		isMobile() 
		&& isLoggedOn 
		&& !onChangePasswordScreen
	) {
		<div 
			id="primaryNav" 
			class="d-flex align-items-center w-100"		
		>
			<button
				aria-label="Open menu"
				[attr.aria-expanded]="this.currMainNavMenu !== ''"
				aria-controls="pcgTopClickNavEl"
				#mainHamburger
				(click)="toggleNav()"
				id="mainHamburger"
				class="btn"
			>
				<fa-icon 
					[icon]="faIconName.faBars" 
					class="hamburger-icon"
				></fa-icon>
			</button>
			<div 
				role="banner" 
				class="navbar-header" 
				[routerLink]="['/']"
			>
				Schedule2.IT
				@if (!isProduction) { <div class="beta-text"></div> }
			</div>
		</div>
	}
	<!--#endregion-->

	<!--#region Secondary nav -->
	@if (
		navService.currNav() 
		&& navService.currNav().id !== 'root'
		&& !navService.currNav()?.hideSecondary
	) {
		<div 
			id="secondaryNav" 
			class="left-shift"
		>
			<div class="name-wrapper">
				<span class="current-section">{{ mainNavTitle() }}</span> <!--breadcrumbs-->
			</div>
			
			<!-- secondary nav items -->
			<s2-top-secondary-nav
				role="navigation"
				aria-label="Secondary"
				[forceSelect]="currForceSelect"
				[rootNavId]="'root' + navDividerCharacter + navService.currNav()?.id?.split(navDividerCharacter)[1]"
				[routeNavId]="navService.currNav()?.id"
				[navRoutes]="navService.currNav()?.children"
				[tabPanel]="tabPanel"
				(clickedNav)="setSubNavPosition()"
			></s2-top-secondary-nav>
		</div>
	}
	<!--#endregion-->
    <pcg-sse-notification class="w-100"></pcg-sse-notification>
</nav>